import { getRgObjectsOfType as i, RG_TYPE as n } from "@project-rouge/rg-core";
import { getFootprint as g } from "./index21.js";
import { getArea as p } from "../index3.js";
const c = (t) => {
  const o = i(t, n.Building), e = g(o), r = p(t);
  return r === 0 ? 0 : e / r;
};
export {
  c as getLandCoverage
};
//# sourceMappingURL=index30.js.map
